module.exports = __webpack_public_path__ + "static/media/d74ac7338668caa0cbbbc85a06dfd24f.6f553406.png";